<template>
    <div class="top-bar">
        <div class="logo"></div>
        <div class="bar">
            <router-link :class="{'bar-button':true,show:items.show}" v-for="items in barList" :to="{name:items.path}"
                         :key="items.name">
                {{items.name}}
            </router-link>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "tableBar",
        watch: {
            $route: {
                handler: function (val, oldVal) {

                    for (let i = 0; i < this.barList.length; i++) {
                        this.barList[i].path === val.name ?
                            this.barList[i].show = true : this.barList[i].show = false
                    }
                },
                // 深度观察监听
                deep: true
            }
        },
        mounted() {
            if (this.$route.name === 'Index') {
                // this.$router.push({name:'Home'})
            }
        },
        data() {
            return {
                barList: [
                    {
                        name: '首页',
                        path: 'Index',
                        show: false

                    },
                    {
                        name: '付费资讯',
                        path: 'Consultation',
                        show: false

                    },
                    {
                        name: '关于我们',
                        path: 'About',
                        show: false

                    },
                    {
                        name: '联系我们',
                        path: 'Contact',
                        show: false

                    }
                ]
            }
        }
    }
</script>

<style scoped lang="scss">
    .top-bar {
        width: 100%;
        height: 68.5px;
        padding: 0px 21px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;

        .logo {
            width: 206px;
            height: 100%;
            background: url("../assets/img/logo.png") center/contain no-repeat;
        }

        .bar {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .bar-button {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(51, 51, 51, 1);
                letter-spacing: 1px;
                height: 100%;
                padding: 0 17px;
            }
        }
    }

    .show {
        color: rgba(158, 60, 60, 1) !important;
    }
</style>